import { memo, useMemo } from 'react';
import { TextInput } from 'react-native';
import AppColors from '../common/colors';
import TvPressable from './tv_pressable';
import useGlobalStyles from '../common/style_context';

type Props = {
  value?: string;
  placeholder?: string;
  focused?: boolean;
  secured?: boolean;
  onPress?: () => void;
};

const inactiveColor = '#6F6F6F';

const styles = [
  `fs=32,fw=500,c=white,ph=24,pv=12,bw=2,br=8,bc=${inactiveColor}`,
  `fs=32,fw=500,c=white,ph=24,pv=12,bw=2,br=8,bc=${AppColors.mainBlue}`,
];

const TextView = memo<Props>(
  ({ value, placeholder, focused, secured, onPress }) => {
    const text = useMemo(
      () => (secured ? '●'.repeat(value?.length ?? 0) : value),
      [value, secured],
    );

    const [container, focusedContainer] = useGlobalStyles(styles);

    return (
      <TvPressable onPress={onPress}>
        <TextInput
          value={text}
          placeholder={placeholder}
          placeholderTextColor={inactiveColor}
          readOnly
          numberOfLines={1}
          focusable={false}
          tvFocusable={false}
          tabIndex={-1}
          style={focused ? focusedContainer : container}
        />
      </TvPressable>
    );
  },
);

export default TextView;
